export default __webpack_public_path__ + "static/media/nuvemshop-next-logo-black.a643ded7.svg";